import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function getLocale() {
  return localStorage.getItem('language') === null ? 'tr' : localStorage.getItem('language')
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'tr',
  messages: loadLocaleMessages()
})

export default i18n